module.exports = __webpack_public_path__ + "img/Progress-Report-Process-2.0139a35f.png";